import { FormattedMessage } from "react-intl"
import banner from "modules/linetex/components/Banner/img/banner.jpg"
import ContactForm from "components/ContactForm"
import { COUNTRY_COLOMBIA } from "consts/countryCodes"

export const SLIDE = [
  {
    id: "slide-linetex",
    imageThumb: banner,
    title: (
      <FormattedMessage
        id="Linetex.Banner.title"
        description="Linetex title banner"
        defaultMessage="Linetex<sup>®</sup>"
        values={{ sup: (...chunks) => <sup>{chunks}</sup> }}
      />
    ),
    description: (
      <FormattedMessage
        id="Linetex.Banner.description"
        description="Linetex description banner"
        defaultMessage="Nuevo diseño tipo textil apta para tapicería exterior e interior"
      />
    ),
    form: (
      <ContactForm
        theme="light"
        styleContainer="container-fluid upholstery-glassmorphism my-3"
        styleFormContainer="p-4"
        title={
          <FormattedMessage
            id="Pranna.Contact.title"
            description="Floors section title contact"
            defaultMessage="¿ Quieres más información ?"
          />
        }
        countryOptions={COUNTRY_COLOMBIA}
        landingSource="linetex"
        isBasic
      />
    )
  }
]
